import { shouldForwardProp } from '@ori/presentation-utils';
import { ArrowRight } from '@ori-ui/icons';
import { styled } from '@ori-ui/mui';
export var Root = styled('div', {
  shouldForwardProp: shouldForwardProp()
})({
  display: 'flex',
  position: 'relative'
});
export var PlayButton = styled('div', {
  name: 'Video',
  slot: 'PlayButton',
  shouldForwardProp: shouldForwardProp()
})(function (_ref) {
  var theme = _ref.theme,
    isPlaying = _ref.isPlaying;
  return {
    background: theme.palette.action.active,
    borderRadius: '50%',
    cursor: 'pointer',
    display: isPlaying ? 'none' : 'block',
    height: '85px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    webkitTransform: 'translate(-50%, -50%)',
    transition: theme.transitions.create(['background-color'], {
      duration: theme.transitions.duration.short
    }),
    width: '85px',
    zIndex: '1',
    '&:hover': {
      background: theme.palette.common.black
    }
  };
});
export var PlayIcon = styled(ArrowRight, {
  name: 'Video',
  slot: 'PlayIcon',
  shouldForwardProp: shouldForwardProp()
})(function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(54),
    left: '50%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)'
  };
});
export var Player = styled('video', {
  name: 'Video',
  slot: 'Player',
  shouldForwardProp: shouldForwardProp()
})(function (_ref3) {
  var isPlaceholderVisible = _ref3.isPlaceholderVisible;
  return {
    display: isPlaceholderVisible ? 'none' : 'unset',
    maxWidth: '100%',
    position: 'relative'
  };
});
//# sourceMappingURL=styles.js.map